import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2, Plus, Trash2, Award, ExternalLink, Printer, Eye, FileText, UserPlus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { printPracticeCertificates } from "@/utils/printCertificate";

const T = {
  title: "\u054E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0576\u0565\u0580",
  subtitle: "\u0531\u057E\u0565\u056C\u0561\u0581\u0580\u0565\u0584 \u057E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u056B \u0576\u056F\u0561\u0580\u0568 \u0587 \u0570\u057D\u056F\u056B\u0579 \u0570\u0561\u0574\u0561\u0580\u0568\u055D \u056F\u0561\u0575\u0584\u0578\u0582\u0574 \u057A\u0561\u0577\u057F\u0578\u0576\u0561\u056F\u0561\u0576 \u057D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0580",
  number: "\u0540\u057D\u056F\u056B\u0579 \u0570\u0561\u0574\u0561\u0580",
  student: "\u0531\u0576\u0578\u0582\u0576 \u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
  course: "\u0534\u0561\u057D\u0568\u0576\u0569\u0561\u0581",
  date: "\u054F\u0580\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
  image: "\u054E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u056B \u0576\u056F\u0561\u0580",
  notes: "\u0546\u0577\u0578\u0582\u0574\u0576\u0565\u0580",
  valid: "\u054E\u0561\u057E\u0565\u0580",
  add: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C",
  saving: "\u054A\u0561\u0570\u057A\u0561\u0576\u057E\u0578\u0582\u0574 \u0567...",
  added: "\u054E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0576 \u0561\u057E\u0565\u056C\u0561\u0581\u057E\u0565\u0581",
  deleted: "\u054E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0568 \u057B\u0576\u057B\u057E\u0565\u0581",
  updated: "\u0539\u0561\u0580\u0574\u0561\u0581\u057E\u0565\u0581",
  errorLoad: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u057E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0576\u0565\u0580\u0568",
  errorSave: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057A\u0561\u0570\u057A\u0561\u0576\u0565\u056C \u057E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0568",
  errorDelete: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057B\u0576\u057B\u0565\u056C \u057E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0568",
  required: "\u053C\u0580\u0561\u0581\u0580\u0565\u0584 \u0570\u057D\u056F\u056B\u0579 \u0570\u0561\u0574\u0561\u0580\u0568, \u0561\u0576\u0578\u0582\u0576\u0568 \u0587 \u0564\u0561\u057D\u0568\u0576\u0569\u0561\u0581\u0568",
  duplicate: "\u0531\u0575\u057D \u0570\u057D\u056F\u056B\u0579 \u0570\u0561\u0574\u0561\u0580\u0576 \u0561\u0580\u0564\u0565\u0576 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0578\u0582\u0576\u056B",
  empty: "\u0534\u0565\u057C \u057E\u056F\u0561\u0575\u0561\u056F\u0561\u0576\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
  view: "\u0534\u056B\u057F\u0565\u056C",
  success: "\u0540\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
  error: "\u054D\u056D\u0561\u056C",
  print: "\u054F\u057A\u0565\u056C A4",
  printAll: "\u054F\u057A\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568 (A4)",
  sample: "\u0546\u0574\u0578\u0582\u0577",
  invalidLabel: "\u0549\u0565\u0572\u0561\u0580\u056F\u057E\u0561\u056E",
  blank: "\u0534\u0561\u057F\u0561\u0580\u056F \u0576\u0574\u0578\u0582\u0577",
  blankTitle: "\u0534\u0561\u057F\u0561\u0580\u056F \u057D\u0565\u0580\u057F\u056B\u0556\u056B\u056F\u0561\u057F\u056B \u0576\u0574\u0578\u0582\u0577",
  blankHint: "\u053C\u0580\u0561\u0581\u0580\u0565\u0584 \u0574\u056B\u0561\u0575\u0576 \u0561\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0564\u0561\u0577\u057F\u0565\u0580\u0568\u2024 \u0564\u0561\u057F\u0561\u0580\u056F \u0564\u0561\u0577\u057F\u0565\u0580\u0568 \u0576\u0574\u0578\u0582\u0577\u056B \u057E\u0580\u0561 \u056F\u0574\u0576\u0561\u0576 \u0564\u0561\u057F\u0561\u0580\u056F\u0589",
  purpose: "\u053B\u0576\u0579\u056B \u0570\u0561\u0574\u0561\u0580 \u0567 \u057F\u0580\u057E\u0578\u0582\u0574 (\u0564\u0561\u057D\u0568\u0576\u0569\u0561\u0581 / \u0576\u057A\u0561\u057F\u0561\u056F)",
  printBlank: "\u054F\u057A\u0565\u056C \u0576\u0574\u0578\u0582\u0577\u0568",
  students: "\u0548\u0582\u057D\u0561\u0576\u0578\u0572\u0576\u0565\u0580",
  addStudent: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0578\u0582\u057D\u0561\u0576\u0578\u0572",
  save: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
};

interface Certificate {
  id: string;
  certificate_number: string;
  student_name: string;
  course_name: string;
  issue_date: string;
  image_url: string | null;
  notes: string | null;
  is_valid: boolean;
}

export const CertificatesSection = () => {
  const { toast } = useToast();
  const [items, setItems] = useState<Certificate[]>([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [form, setForm] = useState({
    certificate_number: "",
    student_name: "",
    course_name: "",
    issue_date: new Date().toISOString().slice(0, 10),
    notes: "",
  });
  const [blankOpen, setBlankOpen] = useState(false);
  const [blank, setBlank] = useState({ student_name: "", purpose: "", issue_date: new Date().toISOString().slice(0, 10) });
  const [editItem, setEditItem] = useState<Certificate | null>(null);
  const [editNames, setEditNames] = useState<string[]>([""]);
  const [editCourse, setEditCourse] = useState("");

  const saveStudents = async () => {
    if (!editItem) return;
    const names = editNames.map((n) => n.trim()).filter(Boolean).join("\n");
    setSaving(true);
    const { error } = await supabase
      .from("certificates")
      .update({ student_name: names, course_name: editCourse.trim() })
      .eq("id", editItem.id);
    setSaving(false);
    if (error) {
      toast({ title: T.error, description: T.errorSave, variant: "destructive" });
      return;
    }
    setItems((prev) => prev.map((c) => (c.id === editItem.id ? { ...c, student_name: names, course_name: editCourse.trim() } : c)));
    toast({ title: T.success, description: T.updated });
    setEditItem(null);
  };


  const printBlank = () => {
    const ok = printPracticeCertificates(
      [
        {
          certificate_number: `GITA-B-${new Date().toISOString().replace(/\D/g, "")}`,
          student_name: blank.student_name.trim(),
          course_name: blank.purpose.trim(),
          issue_date: blank.issue_date,
          notes: null,
          blank_template: true,
        },
      ],
      false,
    );
    if (ok) setBlankOpen(false);
  };

  const fetchItems = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("certificates")
      .select("*")
      .order("created_at", { ascending: false });
    if (error) {
      toast({ title: T.error, description: T.errorLoad, variant: "destructive" });
    } else {
      setItems((data || []) as Certificate[]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.certificate_number.trim() || !form.student_name.trim() || !form.course_name.trim()) {
      toast({ title: T.error, description: T.required, variant: "destructive" });
      return;
    }

    setSaving(true);
    try {
      let imagePath: string | null = null;
      if (file) {
        const ext = file.name.split(".").pop();
        imagePath = `${form.certificate_number.trim().replace(/[^a-zA-Z0-9-_]/g, "_")}-${Date.now()}.${ext}`;
        const { error: uploadError } = await supabase.storage.from("certificates").upload(imagePath, file);
        if (uploadError) throw uploadError;
      }

      const { error } = await supabase.from("certificates").insert({
        certificate_number: form.certificate_number.trim(),
        student_name: form.student_name.trim(),
        course_name: form.course_name.trim(),
        issue_date: form.issue_date,
        notes: form.notes.trim() || null,
        image_url: imagePath,
      });

      if (error) {
        toast({
          title: T.error,
          description: error.code === "23505" ? T.duplicate : T.errorSave,
          variant: "destructive",
        });
        return;
      }

      toast({ title: T.success, description: T.added });
      setForm({
        certificate_number: "",
        student_name: "",
        course_name: "",
        issue_date: new Date().toISOString().slice(0, 10),
        notes: "",
      });
      setFile(null);
      fetchItems();
    } catch {
      toast({ title: T.error, description: T.errorSave, variant: "destructive" });
    } finally {
      setSaving(false);
    }
  };

  const toggleValid = async (item: Certificate) => {
    const { error } = await supabase
      .from("certificates")
      .update({ is_valid: !item.is_valid })
      .eq("id", item.id);
    if (error) {
      toast({ title: T.error, description: T.errorSave, variant: "destructive" });
      return;
    }
    setItems((prev) => prev.map((c) => (c.id === item.id ? { ...c, is_valid: !c.is_valid } : c)));
    toast({ title: T.success, description: T.updated });
  };

  const remove = async (item: Certificate) => {
    const { error } = await supabase.from("certificates").delete().eq("id", item.id);
    if (error) {
      toast({ title: T.error, description: T.errorDelete, variant: "destructive" });
      return;
    }
    if (item.image_url) {
      await supabase.storage.from("certificates").remove([item.image_url]);
    }
    setItems((prev) => prev.filter((c) => c.id !== item.id));
    toast({ title: T.success, description: T.deleted });
  };

  const openImage = async (path: string) => {
    const { data } = await supabase.storage.from("certificates").createSignedUrl(path, 300);
    if (data?.signedUrl) window.open(data.signedUrl, "_blank");
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Award className="h-5 w-5 text-green-600" />
            {T.title}
          </CardTitle>
          <p className="text-sm text-muted-foreground">{T.subtitle}</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="grid gap-4 md:grid-cols-2">
            <div className="space-y-2">
              <Label>{T.number}</Label>
              <Input
                value={form.certificate_number}
                onChange={(e) => setForm({ ...form, certificate_number: e.target.value })}
                placeholder="GITA-2026-0001"
              />
            </div>
            <div className="space-y-2">
              <Label>{T.student}</Label>
              <Input
                value={form.student_name}
                onChange={(e) => setForm({ ...form, student_name: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <Label>{T.course}</Label>
              <Input
                value={form.course_name}
                onChange={(e) => setForm({ ...form, course_name: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <Label>{T.date}</Label>
              <Input
                type="date"
                value={form.issue_date}
                onChange={(e) => setForm({ ...form, issue_date: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <Label>{T.image}</Label>
              <Input
                type="file"
                accept="image/*,application/pdf"
                onChange={(e) => setFile(e.target.files?.[0] ?? null)}
              />
            </div>
            <div className="space-y-2">
              <Label>{T.notes}</Label>
              <Textarea
                rows={1}
                value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })}
              />
            </div>
            <div className="md:col-span-2">
              <Button type="submit" disabled={saving} className="bg-primary hover:bg-primary/90">
                {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Plus className="mr-2 h-4 w-4" />}
                {saving ? T.saving : T.add}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="mb-3 flex justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                printPracticeCertificates(
                  [
                    {
                      certificate_number: "GITA-2026-0001",
                      student_name: "\u0531\u0576\u0578\u0582\u0576 \u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
                      course_name: "\u054E\u0565\u0562 \u056E\u0580\u0561\u0563\u0580\u0561\u057E\u0578\u0580\u0578\u0582\u0574",
                      issue_date: new Date().toISOString().slice(0, 10),
                      notes: null,
                    },
                  ],
                  false,
                )
              }
            >
              <Eye className="mr-1 h-4 w-4" />
              {T.sample}
            </Button>
            <Dialog open={blankOpen} onOpenChange={setBlankOpen}>
              <DialogTrigger asChild>
                <Button variant="outline" size="sm">
                  <FileText className="mr-1 h-4 w-4" />
                  {T.blank}
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-md">
                <DialogHeader>
                  <DialogTitle>{T.blankTitle}</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-muted-foreground">{T.blankHint}</p>
                <div className="space-y-3">
                  <div>
                    <Label>{T.student}</Label>
                    <Input
                      value={blank.student_name}
                      onChange={(e) => setBlank({ ...blank, student_name: e.target.value })}
                      placeholder="........................"
                    />
                  </div>
                  <div>
                    <Label>{T.purpose}</Label>
                    <Input
                      value={blank.purpose}
                      onChange={(e) => setBlank({ ...blank, purpose: e.target.value })}
                      placeholder="........................"
                    />
                  </div>
                  <div>
                    <Label>{T.date}</Label>
                    <Input
                      type="date"
                      value={blank.issue_date}
                      onChange={(e) => setBlank({ ...blank, issue_date: e.target.value })}
                    />
                  </div>
                  <Button className="w-full" onClick={printBlank}>
                    <Printer className="mr-2 h-4 w-4" />
                    {T.printBlank}
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
            {items.some((c) => c.is_valid) && (
              <Button variant="outline" size="sm" onClick={() => printPracticeCertificates(items.filter((c) => c.is_valid))}>
                <Printer className="mr-1 h-4 w-4" />
                {T.printAll}
              </Button>
            )}
          </div>
          {loading ? (
            <div className="flex justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin" />
            </div>
          ) : items.length === 0 ? (
            <p className="py-8 text-center text-sm text-muted-foreground">{T.empty}</p>
          ) : (
            <div className="space-y-3">
              {items.map((item) => (
                <div
                  key={item.id}
                  className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center sm:justify-between"
                >
                  <div className="space-y-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-semibold">{item.certificate_number}</span>
                      {!item.is_valid && <Badge variant="destructive">{T.invalidLabel}</Badge>}
                    </div>
                    <div className="text-sm text-muted-foreground">
                      {item.student_name.split("\n").join(", ")} — {item.course_name} — {item.issue_date}
                    </div>
                  </div>
                  <div className="flex flex-wrap items-center gap-3">
                    {item.image_url && (
                      <Button variant="outline" size="sm" onClick={() => openImage(item.image_url as string)}>
                        <ExternalLink className="mr-1 h-4 w-4" />
                        {T.view}
                      </Button>
                    )}
                    <Button variant="outline" size="sm" onClick={() => { setEditItem(item); setEditNames(item.student_name ? item.student_name.split("\n") : [""]); setEditCourse(item.course_name); }}>
                      <UserPlus className="mr-1 h-4 w-4" />
                      {T.students}
                    </Button>
                    <Button variant="outline" size="sm" onClick={() => printPracticeCertificates([item])}>
                      <Printer className="mr-1 h-4 w-4" />
                      {T.print}
                    </Button>
                    <div className="flex items-center gap-2">
                      <Switch checked={item.is_valid} onCheckedChange={() => toggleValid(item)} />
                      <span className="text-xs text-muted-foreground">{T.valid}</span>
                    </div>
                    <Button variant="ghost" size="sm" onClick={() => remove(item)}>
                      <Trash2 className="h-4 w-4 text-red-500" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
      <Dialog open={!!editItem} onOpenChange={(o) => !o && setEditItem(null)}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{T.students} — {editItem?.certificate_number}</DialogTitle>
          </DialogHeader>
          <div className="space-y-3">
            <div>
              <Label>{T.course}</Label>
              <Input value={editCourse} onChange={(e) => setEditCourse(e.target.value)} />
            </div>
            <Label>{T.student}</Label>
            {editNames.map((n, i) => (
              <div key={i} className="flex gap-2">
                <Input
                  value={n}
                  maxLength={100}
                  onChange={(e) => setEditNames(editNames.map((x, j) => (j === i ? e.target.value : x)))}
                />
                <Button variant="ghost" size="sm" onClick={() => setEditNames(editNames.filter((_, j) => j !== i))}>
                  <Trash2 className="h-4 w-4 text-destructive" />
                </Button>
              </div>
            ))}
            <Button variant="outline" size="sm" onClick={() => setEditNames([...editNames, ""])}>
              <Plus className="mr-1 h-4 w-4" />
              {T.addStudent}
            </Button>
            <Button className="w-full" onClick={saveStudents} disabled={saving}>
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {T.save}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
